










































import axios from 'axios'
import EventPage, { IEventPage } from '@/models/EventPage'
import {apiV1AdminEventPagePath, apiV1AdminEventPagesPath} from '@/rails/routes'
import { Component } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import ListCount from '@/components/admin/ListCount.vue'

@Component({
  components: {
    ListCount
  }
})
export default class EventPageIndex extends PageBase {
  headers: Array<DataTableHeader> = [
    { text: '', value: 'actions', sortable: false, width: 80 },
    { text: 'タイトル', value: 'title' },
  ]
  eventPages: Array<EventPage> = []
  keyword = ''
  selected = []

  get filtered(): Array<EventPage> {
    if (this.keyword) {
      return this.eventPages.filter(
        event => {
          return event.title.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase()) ||
            event.content.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase())
        }
      )
    }
    return this.eventPages
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'イベントページ一覧'
      }
    ]
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const eventPages = await axios.get<Array<IEventPage>>(apiV1AdminEventPagesPath())
      this.eventPages = eventPages.data.map(m => new EventPage(m))
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  destroy(): void {
    this.showConfirm({
      title: '削除', message: `選択した${this.selected.length}件を削除しますか？`, onClosed: async (result) => {
        if (result) {
          for (let i = 0; i < this.selected.length; i++) {
            await axios.delete(apiV1AdminEventPagePath(this.selected[i]))
          }
          this.showMessage(`${this.selected.length}件の削除が完了しました`)
          this.selected = []
          await this.reload()
        }
      }
    })
  }
}
